import { Image, Checkbox, Input, Collapse, message } from "antd";
import { useEffect, useState } from "react";
import { INVENTORY_VARIANT_TABS_BGCOLORS } from "../../../constant/constants";

export default function VariantInput({
  updateRecipeVariantField,
  index,
  collapseActiveKey,
  variant,
  handleTabChange = () => {},
  handleCollapseEdit = () => {},
  setSelectedCollapseKey = () => {},
  setSelectedVariantId = () => {},
  setRecipeVariants = () => {},
  recipeVariants = [],
  firstTempVariantId,
  isEdit = false,
}) {
  const { tempVarId, name, isSelected, tempCollapseKey, optionId } = variant;
  const [variantName, setVariantName] = useState("");
  const [variantTempName, setVariantTempName] = useState("");
  const [variantChecked, setVariantChecked] = useState(false);

  useEffect(() => {
    setVariantTempName(name || "");
    setVariantName(name || "");
    setVariantChecked(isSelected || false);
  }, [name, isSelected]);

  function onHandleVariantTempName(e) {
    const tempName = e.target.value;

    if (tempName.length > 100) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          You have reached your limit! Please make <span className="text-red-500"> variants name</span> less than
          <span className="text-red-500"> 100 character</span>.
        </p>
      );
      return;
    }

    if (tempName.toLowerCase().includes("system default") || tempName.toLowerCase().includes("default")) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          You can not set variant name as <span className="text-red-500">System Default or Default</span>
        </p>
      );
      setVariantTempName("");
      return;
    }

    // for (let variant of recipeVariants) {
    //   if (tempName!== "" && (variant.name.trim().toLowerCase() === tempName.trim().toLowerCase())) {
    //     message.warning(
    //       <p className="font-p_regular text-[12px]">
    //         <span className="text-red-500">Variants name</span> can not be same!
    //       </p>
    //     );
    //     setVariantTempName("");
    //     return;
    //   }
    // }

    setVariantTempName(tempName);
  }

  function onHandleVariantChecked(e, tempVarId) {
    if (e.target.checked) {
      setSelectedCollapseKey();
      setSelectedVariantId(tempVarId);
      updateRecipeVariantField("variants", tempVarId, "isSelected", true);
      setVariantChecked(true);
    } else {
      updateRecipeVariantField("variants", tempVarId, "isSelected", false);
      setVariantChecked(false);
    }
  }

  function clearFields() {
    setVariantName(name);
    setVariantTempName(name);
    setSelectedCollapseKey();
  }

  function onHandleDone() {
    if (variantTempName === "") {
      setVariantName("");
      updateRecipeVariantField("variants", tempVarId, "name", "");
      setSelectedCollapseKey();
      return;
    }
    const variantNameExists = recipeVariants.some(
      (variant) => variant.name === variantTempName
    );

    if (variantNameExists) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          <span className="text-red-500">Variant name</span> cannot be the same!
        </p>
      );
      setVariantTempName("");
      return;
    }

    setVariantName(variantTempName);
    updateRecipeVariantField("variants", tempVarId, "name", variantTempName);
    clearFields();
  }

  function onHandleCancel() {
    // When newly variant is added its variant name and optionId will empty
    // so we can remove the variant from the list
    if (variantName === "" && recipeVariants.length > 1 && optionId === "") {
      setSelectedVariantId(firstTempVariantId);
      setRecipeVariants((prevVariants) => [...prevVariants.filter((item) => item.tempVarId !== tempVarId)]);
      return;
    } else {
      setSelectedVariantId(firstTempVariantId);
    }
    clearFields();
  }

  return (
    <div className="inventory-recipe-variant-left">
      <Collapse
        headerBg={`${INVENTORY_VARIANT_TABS_BGCOLORS[index % INVENTORY_VARIANT_TABS_BGCOLORS.length]}`}
        bordered={false}
        showArrow={false}
        ghost={true}
        accordion
        activeKey={collapseActiveKey === tempCollapseKey ? tempCollapseKey : null}
        // onChange={(e) => handleTabChange(tempVarId)}
        classNames={"w-full"}
        items={[
          {
            key: tempCollapseKey,
            label: (
              <div
                className="flex items-center justify-between h-[42px] px-3 w-[234px] relative"
                style={{
                  backgroundColor: INVENTORY_VARIANT_TABS_BGCOLORS[index % INVENTORY_VARIANT_TABS_BGCOLORS.length],
                }}
                onClick={() => handleTabChange(tempVarId)}
              >
                <Checkbox
                  className="recipe-variant-checkbox"
                  disabled={(isEdit && Boolean(optionId))}
                  checked={variantChecked}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => onHandleVariantChecked(e, tempVarId)}
                />
                <p
                  className={`cursor-pointer text-sm font-bold leading-[16px] w-[120px] truncate text-center cursor-default ${
                    index % INVENTORY_VARIANT_TABS_BGCOLORS.length ? "text-black" : "text-white"
                  }`}
                >
                  {variantName}
                </p>
                <button
                  className={`w-[22px] h-[22px] ${
                    isEdit && variantName !== "" && optionId !== "" ? "bg-gray-300" : "bg-white"
                  } rounded-full flex items-center justify-center`}
                  disabled={isEdit && variantName !== "" && optionId !== ""}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleCollapseEdit(tempCollapseKey, tempVarId);
                  }}
                >
                  <Image src="/images/icons/pencil.svg" alt="edit" preview={false} />
                </button>
              </div>
            ),
            children: (
              <div className="h-[110px] flex flex-col items-center space-y-[32px] mt-[28px]">
                <Input
                  type="text"
                  name="variantName"
                  value={variantTempName}
                  onChange={onHandleVariantTempName}
                  className="w-[176px] border border-px border-[#D5D8DB] rounded-[4px]"
                  placeholder="Variant name"
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) => e.stopPropagation()}
                />

                <div className="flex items-center space-x-2">
                  <button
                    className="text-white bg-red-500 rounded-[5px] w-[65px] h-[28px] font-bold text-xs leading-[15px]"
                    onClick={onHandleCancel}
                  >
                    {variantName === "" && recipeVariants.length > 1 && optionId === "" ? "Cancel" : "Close"}
                  </button>
                  <button
                    className="text-white bg-black rounded-[5px] w-[65px] h-[28px] font-bold text-xs leading-[15px]"
                    onClick={onHandleDone}
                  >
                    Done
                  </button>
                </div>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}
